import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { SectionCard } from '../../components/card'
import { Separator } from '../../components/separator'
import { Stepper } from '../../components/stepper'
import { useNavigate } from 'react-router-dom'
import Dropdown from '../../components/dropdown/dropdown'
import { useAppDispatch, useAppSelector } from '../../redux/hook'
import { conveyancingSolicitorTypeItems, proposedHousingTypeItems, solicitorTypeItems, stepperItems } from '../../utils/shared-dropdown'
import ApplicationCooLayout from '../../layout/application-coo-layout'

import { ApplicationStep3, HDBSolicitor, LegalRepresentation, PrivateSolicitor, TenancyInCommon } from '../../models/classes/ApplicationStep3.class'
import { updateFormData } from '../../redux/slices/application-step-3-slice'
import { useForm } from '../../hooks/use-form'
import { P2Button, P2ButtonGroup, P2Checkbox, P2TextDescription, P2TextLabel } from 'react-bootstrap-common-script'
import { HoldingTypeEnum } from '../../models/enum/holding-type.enum'
import { Owner } from '../../models/polymer/Owner.model'
import { validateConveyancing } from '../../utils/validator'
import { SolicitorTypeEnum } from '../../models/enum/solicitor-type.enum'
import { Radio_Attend_HDB } from '../../utils/shared-radio'
import LegalRepresentationSegment from './conveyancing/legal-representation-segment'
import HoldingTypeSegment from './segments/holding-type.segment'
import RadioGroup from '../../components/form/grouped/radio/radio-group'
import { LoanTypeEnum } from '../../models/enum/loan-type.enum'
import { DropdownItemInterface } from '../../models/interfaces/dropdown-item.interface'
import SolicitorTable from './conveyancing/solicitor-table'
import HoldingTypeTable from './conveyancing/holding-type-table'
import { TextSubheader } from '../../components/text/text-subheader'
import useSaveDraft from '../../hooks/use-save-draft'
import { StructureStatusEnum } from '../../models/enum/structure-status.enum'
import { OwnershipReasonEnum } from '../../models/enum/ownership-reason.enum'
import { updateStageAStep3 } from '../../redux/slices/completed-steps-slice'
import useIdleSaveDraft from '../../hooks/use-idle-save-draft'
import { checkIsFlatResale } from '../../utils/form-helper'
import ValuationStampDutyForm from '../../components/HOC/valuation-stamp-duty-form/valuation-stamp-duty-form'
import { useInitialWindowScrollTo } from '../../hooks/use-initial-window-scroll-to'
import moment from 'moment'
import SaveDraftAlert from '../../components/HOC/stage-a-form/save-draft-alert'
import { API_ApplicationRemove, API_OverrideEligibilityCheck } from '../../utils/api'
import { PolymerAxios } from '../../utils/axios'
import LeavingPageModal from './leaving-page-modal'
import SaveDraftModal from './save-draft-modal'
import BackConfirmationModal from './back-confirmation-modal'
import { cloneDeep } from 'lodash'
import { setBackTriggered, setLastBackTriggeredTime } from '../../redux/slices/back-triggered-slice'
import { Helpers } from '../../utils/helper'
import { ApplicationStep4 } from '../../models/classes/ApplicationStep4.class'
import { updateFormData as updateFormDataStep4 } from '../../redux/slices/application-step-4-slice'
import { updateFormData as updateFormDataStep5 } from '../../redux/slices/application-step-5-slice'
import useCheckRemission from '../../hooks/use-check-remission'
import { ApplicationStep5 } from '../../models/classes/ApplicationStep5.class'
import useGetEligibilityOverride from '../../hooks/use-get-eligibility-override'
import { EligibilityCheck, EligibilityOverride } from '../../models/classes/EligibilityOverride.class'
let activeStep = 3;

function ApplicationCOOStep3() {

  const navigate = useNavigate();
  const AppDispatch = useAppDispatch();
  const { performSaveDraft, performSaveDraftManual } = useSaveDraft();
  useIdleSaveDraft(() => {saveDraft(false)});
  const [isInit, setIsInit] = useState<boolean>(true);
  const [saveDraftSuccess, setSaveDraftSuccess] = useState<boolean>(false);
  const [backConfirmationModalOpen, setBackConfirmationModalOpen] = useState<boolean>(false);
  const [saveDraftModalOpen, setSaveDraftModalOpen] = useState<boolean>(false); 
  const [ forceError, setForceError ] = useState<boolean>(false);
  const loginUserStructureStatus = useAppSelector(state => state.auth.AuthenticationSlice.structureStatus);
  const applicationStartFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const applicationStep1FormData = useAppSelector(state => state.app.ApplicationStep1Slice.formData);
  const applicationStep2FormData = useAppSelector(state => state.app.ApplicationStep2Slice.formData);
  const initApplicationStep3FormData = useAppSelector(state => state.app.ApplicationStep3Slice.formData);
  const startApplicationFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const backTriggeredSlice = useAppSelector(state => state.app.BackTriggeredSlice);
  const applicationId = useAppSelector(state => state.app.ApplicationIdSlice.applicationId);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const anchorRef = useRef<HTMLDivElement>(null);
  

  const isHoldingTypeProposedLegalRequired = useMemo(() => {
    return loginUserStructureStatus !== StructureStatusEnum.outgoing;
  },[loginUserStructureStatus])
  

  
  const { values: ConveyancingValue, errors:ConveyancingErrors, formValid, setFormValue: ConveyancingSetFormValue, setAdditionalData }: { handleChange: any, values: ApplicationStep3, errors: any, formValid: boolean, setFormValue: (update: ApplicationStep3) => void, setAdditionalData:any } = useForm(new ApplicationStep3(), () => { }, validateConveyancing);  
  const { isRemission, displayValuation} = useCheckRemission(applicationStartFormData, applicationStep1FormData,applicationStep2FormData,ConveyancingValue);
  const { bypassSolicitors, bypassPayments } = useGetEligibilityOverride(applicationStartFormData.selected_hdb_property?.hdb_ref);

  const isSoleOwnership = useMemo(()=>{
    return applicationStep1FormData.household.incoming_owners.length === 1;
  },[applicationStep1FormData.household.incoming_owners.length])

  const newLoanType = useMemo(()=>{
    return  applicationStep2FormData.new_loan_type
  },[applicationStep2FormData.new_loan_type]);
  
  const currentLoanType = useMemo(()=>{
    return  applicationStep2FormData.current_loan_type
  },[applicationStep2FormData.current_loan_type]);


  const step_2 = useAppSelector(state => state.app.CompletedStepsSlice.stage_a.step_2);


  const isCurrentDirectConveyancing = useMemo(()=>{
    return currentLoanType === LoanTypeEnum.no_loan || Number(applicationStep2FormData.current_loan_amount) === 0;
  },[currentLoanType, applicationStep2FormData.current_loan_amount])

  const isProposedDirectConveyancing = useMemo(()=>{
    return newLoanType === LoanTypeEnum.no_loan
  },[newLoanType])

  useEffect(()=>{
    if(!step_2){
      navigate('/application-coo/stage-a/declaration')
    }
  },[step_2, navigate])

  useEffect(()=>{
    setForceError(false);
  },[ConveyancingValue])

  useInitialWindowScrollTo();

  const scrollToTable = useCallback(() => {
    window.scrollTo(0, anchorRef.current?.offsetTop ?? 0);
  }, [anchorRef]);


  const isFlatResale = useMemo(()=>{
    return checkIsFlatResale(applicationStartFormData.selected_hdb_property?.financing_info.sales_type_code!); 
  },[applicationStartFormData.selected_hdb_property?.financing_info.sales_type_code]);

  useEffect(() => {
    if(!displayValuation) {
      ConveyancingSetFormValue({...ConveyancingValue, valuation: "", estimated_market_value: ""});
    }
  }, [displayValuation])

  useEffect(()=>{
    setIsInit(true);
    let timeoutID: number;
    timeoutID = window.setTimeout(() => {
      setIsInit(false);
       //holding type might be undefined if previous form filled is under logged in outgoing owner
      if(initApplicationStep3FormData.holding_type || initApplicationStep3FormData.current_solicitor_type){
        //has Initial
        //When sole ownership, assigned a predefined holding type = sole ownership and isConfirmed = true, so the proposed holding type section will be hide
        const initConveyancing = cloneDeep(initApplicationStep3FormData.tenancy_in_common);
        const formValue = {...initApplicationStep3FormData, tenancy_in_common:initConveyancing};
        if(!isHoldingTypeProposedLegalRequired){
            formValue.proposed = new LegalRepresentation();
            formValue.proposed_solicitor_type = undefined;
            formValue.proposed_same_solicitor = undefined;
            formValue.holding_type = undefined;
        }

        let isSoleObj = {
          holding_type: isSoleOwnership? HoldingTypeEnum.sole_ownership : initApplicationStep3FormData.holding_type,
          is_holding_type_confirm: isSoleOwnership ? true : initApplicationStep3FormData.is_holding_type_confirm
        }

        ConveyancingSetFormValue({...formValue, ...isSoleObj});
      }
      else{
        //When no Initial data,
        //So create TenancyInCommon Initial data
        //Check whether is sole ownership, if yes assigned it.
        const initConveyancing = applicationStep1FormData.household.incoming_owners?.map(e=> new TenancyInCommon({user : new Owner(e)}));

        //When sole ownership, assigned a predefined holding type = sole ownership and isConfirmed = true, so the proposed holding type section will be hide
        let isSoleObj = {
          holding_type: isSoleOwnership? HoldingTypeEnum.sole_ownership : undefined,
          is_holding_type_confirm: isSoleOwnership? true : false,
        }

        ConveyancingSetFormValue({...ConveyancingValue, tenancy_in_common:initConveyancing, ...isSoleObj, proposed_solicitor_type: undefined, current_solicitor_type : undefined, proposed: new LegalRepresentation(), current: new LegalRepresentation() });
      }
    },500);
    
    return () => {
      clearTimeout(timeoutID);
    }
   
    //INIT commonTenancy,
  },[initApplicationStep3FormData, applicationStep1FormData, isSoleOwnership, isHoldingTypeProposedLegalRequired, isFlatResale])

  useEffect(() => {
    if(ConveyancingValue.proposed_same_solicitor && (ConveyancingValue.current.hdb_solicitor.is_confirm || ConveyancingValue.current.private_solicitor.is_confirm)){
      ConveyancingSetFormValue({...ConveyancingValue, proposed_solicitor_type: ConveyancingValue.current_solicitor_type, proposed: new LegalRepresentation(ConveyancingValue.current)});
    }
  },[ConveyancingValue.current, ConveyancingValue.current_solicitor_type])

  const onSelectSameSolicitor = useCallback(() =>{
    if(!ConveyancingValue.proposed_same_solicitor){
      ConveyancingSetFormValue({...ConveyancingValue, proposed_same_solicitor : !ConveyancingValue.proposed_same_solicitor, proposed_solicitor_type: ConveyancingValue.current_solicitor_type, proposed: new LegalRepresentation(ConveyancingValue.current)});
    }
    else{
      ConveyancingSetFormValue({...ConveyancingValue, proposed_same_solicitor : !ConveyancingValue.proposed_same_solicitor, proposed_solicitor_type: undefined, proposed: new LegalRepresentation()});
    }
  }, [ConveyancingValue, ConveyancingSetFormValue]);

  const isProposedConveyancingHdb = useMemo(() => {
    return ConveyancingValue.proposed.hdb_solicitor.represented_same_solicitor === true || ConveyancingValue.proposed_solicitor_type === SolicitorTypeEnum.conveyancing_hdb_solicitor;
  }, [ConveyancingValue])


  const isCurrentConveyancingValid = useMemo(()=>{
    try{
      if(isCurrentDirectConveyancing){
        if(ConveyancingValue.current_solicitor_type === SolicitorTypeEnum.conveyancing_hdb_solicitor){
          return ConveyancingValue?.current.hdb_solicitor.is_confirm;
        }
        else if(ConveyancingValue.current_solicitor_type === SolicitorTypeEnum.conveyancing_private_solicitor){
          return ConveyancingValue?.current.conveyancing_private_solicitor.is_confirm ?? false;
        }
        return false;
      }
      else{
        if(ConveyancingValue.current_solicitor_type === SolicitorTypeEnum.hdb_solicitor){
          if(ConveyancingValue.current.hdb_solicitor.represented_same_solicitor === false){
            //check conveyancing values
            return ConveyancingValue.current.hdb_solicitor.is_confirm && ConveyancingValue?.current.conveyancing_private_solicitor.is_confirm;
          }
          return ConveyancingValue.current.hdb_solicitor.is_confirm;
        }
        else if(ConveyancingValue.current_solicitor_type === SolicitorTypeEnum.private_solicitor){
          if(ConveyancingValue.current.private_solicitor.represented_same_solicitor === false){
            //check conveyancing values
            return ConveyancingValue.current.private_solicitor.is_confirm && ConveyancingValue?.current.conveyancing_private_solicitor.is_confirm;
          }
          return ConveyancingValue.current.private_solicitor.is_confirm;
        }
        else{
          return false;
        }
      }
    }
    catch(e){
      console.warn("isCurrentConveyancingValid CATCH",e);
      return false;
    }
    
  },[ConveyancingValue, isCurrentDirectConveyancing])

  
  const isProposedConveyancingValid = useMemo(()=>{
    try{
      if(!isHoldingTypeProposedLegalRequired){
        //isOutgoing will be true
        return true;
      }
      if(ConveyancingValue.proposed_solicitor_type === SolicitorTypeEnum.hdb_solicitor){
        if(ConveyancingValue.proposed.hdb_solicitor.represented_same_solicitor === false){
          //check conveyancing values
          return ConveyancingValue.proposed.hdb_solicitor.is_confirm && ConveyancingValue?.proposed.conveyancing_private_solicitor.is_confirm;
        }
        return ConveyancingValue.proposed.hdb_solicitor.is_confirm;
      }
      else if(ConveyancingValue.proposed_solicitor_type === SolicitorTypeEnum.private_solicitor){
        if(ConveyancingValue.proposed.private_solicitor.represented_same_solicitor === false){
          //check conveyancing values
          return ConveyancingValue.proposed.private_solicitor.is_confirm && ConveyancingValue?.proposed.conveyancing_private_solicitor.is_confirm;
        }
        return ConveyancingValue.proposed.private_solicitor.is_confirm;
      }
      else if(ConveyancingValue.proposed_solicitor_type === SolicitorTypeEnum.conveyancing_hdb_solicitor){
        return ConveyancingValue?.proposed.hdb_solicitor.is_confirm;
      }
      else if(ConveyancingValue.proposed_solicitor_type === SolicitorTypeEnum.conveyancing_private_solicitor){
        return ConveyancingValue?.proposed.conveyancing_private_solicitor.is_confirm ?? false;
      }
      else{
        return false;
      }
    }
    catch(e){
      console.warn("isProposedConveyancingValid CATCH",e);
      return false;
    }
    
  },[ConveyancingValue.proposed.conveyancing_private_solicitor.is_confirm, ConveyancingValue.proposed.hdb_solicitor.is_confirm, ConveyancingValue.proposed.hdb_solicitor.represented_same_solicitor, ConveyancingValue.proposed.private_solicitor.is_confirm, ConveyancingValue.proposed.private_solicitor.represented_same_solicitor, ConveyancingValue.proposed_solicitor_type, isHoldingTypeProposedLegalRequired])

  const isBtnValid = useMemo(():boolean => {
    console.log(`DEBUG - isBtnValid`, formValid, isProposedConveyancingValid, isCurrentConveyancingValid);
    return formValid && isProposedConveyancingValid && isCurrentConveyancingValid;
  },[formValid, isCurrentConveyancingValid, isProposedConveyancingValid]);


  const proposedDropdownDisabled = useMemo(() =>{
    if(ConveyancingValue.attend_hdb_in_person === undefined){
        return true;
    }

    if(ConveyancingValue.proposed_solicitor_type === SolicitorTypeEnum.hdb_solicitor){
      return ConveyancingValue.proposed?.hdb_solicitor?.is_confirm;
    }
    else if(ConveyancingValue.proposed_solicitor_type === SolicitorTypeEnum.private_solicitor){
      return ConveyancingValue.proposed?.private_solicitor?.is_confirm;
    }
    else{
      return false;
    }
  },[ConveyancingValue])

  const currentDropdownDisabled = useMemo(() =>{
    if(ConveyancingValue.attend_hdb_in_person === undefined){
      return true;
    }
    
    if(ConveyancingValue.current_solicitor_type === SolicitorTypeEnum.hdb_solicitor){
      return ConveyancingValue.current?.hdb_solicitor?.is_confirm;
    }
    else if(ConveyancingValue.current_solicitor_type === SolicitorTypeEnum.private_solicitor){
      return ConveyancingValue.current?.private_solicitor?.is_confirm;
    }
    else{
      return false;
    }
  },[ConveyancingValue])

  const processLegalRepresentationDropdownForCurrent = useMemo(():DropdownItemInterface[]=>{
    if(bypassSolicitors.current === true){
      return isCurrentDirectConveyancing ? conveyancingSolicitorTypeItems : solicitorTypeItems;
    }
    
    const privateSolicitorOnly = isCurrentDirectConveyancing ? conveyancingSolicitorTypeItems.filter(e=>e.value === SolicitorTypeEnum.conveyancing_private_solicitor) : solicitorTypeItems.filter(e=>e.value === SolicitorTypeEnum.private_solicitor);
    
    if (ConveyancingValue.attend_hdb_in_person === false) {
      return privateSolicitorOnly
    }

    const isDivorce = applicationStep1FormData.reason.change_ownership_reason === OwnershipReasonEnum.divorce;
    const isSubmitContent = applicationStep1FormData.reason.submit_content
    const dateOfCourtOrderCheck = applicationStep1FormData.reason.date_of_court_order <= moment().add({months: 3}).format('yyyy-MM-DD')
    if (isDivorce && (isSubmitContent === false || dateOfCourtOrderCheck)) {
      return privateSolicitorOnly;
    }

    const isDemise = applicationStep1FormData.reason.change_ownership_reason === OwnershipReasonEnum.demise_of_current_owner
    const isNotBeneficiary = applicationStep1FormData.reason.is_beneficiary_proposed_owners === "false"
    if(isDemise && isNotBeneficiary){
      return privateSolicitorOnly;
    }

    if (currentLoanType === LoanTypeEnum.bank_loan && Number(applicationStep2FormData.current_loan_amount) > 0) {
      return privateSolicitorOnly;
    }
    
    return isCurrentDirectConveyancing ? conveyancingSolicitorTypeItems : solicitorTypeItems

  },[ConveyancingValue.attend_hdb_in_person, applicationStep1FormData.reason.change_ownership_reason, applicationStep1FormData.reason.date_of_court_order, applicationStep1FormData.reason.is_beneficiary_proposed_owners, applicationStep1FormData.reason.submit_content, currentLoanType, isCurrentDirectConveyancing, applicationStep2FormData.current_loan_amount, bypassSolicitors])
  
  const processLegalRepresentationDropdownForNew = useMemo(():DropdownItemInterface[]=>{
    if(bypassSolicitors.proposed === true){
      return isProposedDirectConveyancing ? conveyancingSolicitorTypeItems : solicitorTypeItems;
    }

    const privateSolicitorOnly = isProposedDirectConveyancing ? conveyancingSolicitorTypeItems.filter(e=>e.value === SolicitorTypeEnum.conveyancing_private_solicitor) : solicitorTypeItems.filter(e=>e.value === SolicitorTypeEnum.private_solicitor);

    if(newLoanType === LoanTypeEnum.bank_loan){
      return privateSolicitorOnly;
    }
    else if(ConveyancingValue.attend_hdb_in_person === false){
      return privateSolicitorOnly;
    } 
    else if(applicationStep1FormData.reason.change_ownership_reason === OwnershipReasonEnum.divorce){
      if(applicationStep1FormData.reason.submit_content === false || applicationStep1FormData.reason.date_of_court_order <= moment().add({months: 3}).format('yyyy-MM-DD')){
        return privateSolicitorOnly;
      }
    }
    else if(applicationStep1FormData.reason.change_ownership_reason === OwnershipReasonEnum.demise_of_current_owner){
      if(applicationStep1FormData.reason.is_beneficiary_proposed_owners === "false"){
          return privateSolicitorOnly;
      }
    }
    
    return isProposedDirectConveyancing ? conveyancingSolicitorTypeItems : solicitorTypeItems

  },[ConveyancingValue.attend_hdb_in_person, applicationStep1FormData.reason.change_ownership_reason, applicationStep1FormData.reason.date_of_court_order, applicationStep1FormData.reason.is_beneficiary_proposed_owners, applicationStep1FormData.reason.submit_content, isProposedDirectConveyancing, newLoanType, bypassSolicitors])

  
  const currentLegalRepresentationTitle = useMemo(()=>{
    const hasLoan = currentLoanType !== LoanTypeEnum.no_loan;
    return hasLoan ? "Lawyer for current owners' discharge of current loan:" : "Lawyer for current owners' conveyancing.";
  },[currentLoanType]);
  
  const newLegalRepresentationTitle = useMemo(()=>{
    const hasLoan = newLoanType !== LoanTypeEnum.no_loan;
    return hasLoan ? "Lawyer for proposed owners' new mortgage loan:" : "Lawyer for proposed owners' conveyancing:";
  },[newLoanType]);

  const enableProposeSameSolicitor = useMemo(()=>{
    if((ConveyancingValue.current_solicitor_type === SolicitorTypeEnum.hdb_solicitor && newLoanType === LoanTypeEnum.bank_loan) || (!(ConveyancingValue.current.private_solicitor.is_confirm || ConveyancingValue.current.hdb_solicitor.is_confirm)) || (!ConveyancingValue.current_solicitor_type) || ((!ConveyancingValue.current.private_solicitor.represented_same_solicitor && !ConveyancingValue.current.conveyancing_private_solicitor.is_confirm) && ConveyancingValue.current_solicitor_type === SolicitorTypeEnum.private_solicitor) || ((!ConveyancingValue.current.hdb_solicitor.represented_same_solicitor && !ConveyancingValue.current.conveyancing_private_solicitor.is_confirm) && ConveyancingValue.current_solicitor_type === SolicitorTypeEnum.hdb_solicitor)){
      //disabled it when private or hdb solicitor not confirm
      return false;
    }
    return true;

  },[ConveyancingValue, newLoanType]);

  const isValueChanged = useMemo(() => {
    const initTenancyInCommon =
      initApplicationStep3FormData.tenancy_in_common.length > 0
        ? cloneDeep(initApplicationStep3FormData.tenancy_in_common)
        : applicationStep1FormData.household.incoming_owners?.map(
            (e) => new TenancyInCommon({ user: new Owner(e) })
          );

   
    let oldApplicationForm = new ApplicationStep3({
      ...initApplicationStep3FormData,
      current: new LegalRepresentation({
        ...initApplicationStep3FormData.current,
        hdb_solicitor: new HDBSolicitor({
          ...initApplicationStep3FormData.current.hdb_solicitor,
        }),
        private_solicitor: new PrivateSolicitor({
          ...initApplicationStep3FormData.current.private_solicitor,
        }),
        conveyancing_private_solicitor: new PrivateSolicitor({
          ...initApplicationStep3FormData.current
            .conveyancing_private_solicitor,
        }),
      }),
      proposed: new LegalRepresentation({
        ...initApplicationStep3FormData.proposed,
        hdb_solicitor: new HDBSolicitor({
          ...initApplicationStep3FormData.proposed.hdb_solicitor,
        }),
        private_solicitor: new PrivateSolicitor({
          ...initApplicationStep3FormData.proposed.private_solicitor,
        }),
        conveyancing_private_solicitor: new PrivateSolicitor({
          ...initApplicationStep3FormData.proposed
            .conveyancing_private_solicitor,
        }),
      }),
      tenancy_in_common: initTenancyInCommon,
    });
    let newApplicationForm = new ApplicationStep3({
      ...ConveyancingValue,
      current: new LegalRepresentation({
        ...ConveyancingValue.current,
        hdb_solicitor: new HDBSolicitor({
          ...ConveyancingValue.current.hdb_solicitor,
        }),
        private_solicitor: new PrivateSolicitor({
          ...ConveyancingValue.current.private_solicitor,
        }),
        conveyancing_private_solicitor: new PrivateSolicitor({
          ...ConveyancingValue.current.conveyancing_private_solicitor,
        }),
      }),
      proposed: new LegalRepresentation({
        ...ConveyancingValue.proposed,
        hdb_solicitor: new HDBSolicitor({
          ...ConveyancingValue.proposed.hdb_solicitor,
        }),
        private_solicitor: new PrivateSolicitor({
          ...ConveyancingValue.proposed.private_solicitor,
        }),
        conveyancing_private_solicitor: new PrivateSolicitor({
          ...ConveyancingValue.proposed.conveyancing_private_solicitor,
        }),
      }),
    });

    return Helpers.checkIsValueChanged(oldApplicationForm, newApplicationForm);
  }, [
    initApplicationStep3FormData,
    ConveyancingValue,
    applicationStep1FormData,
    isFlatResale
  ]);

  const saveDraft = useCallback(async(requiredAlert: boolean) => {
    let response;
    if(isValueChanged){
      const newStep4Form = new ApplicationStep4();
      const newStep5Form = new ApplicationStep5();
      AppDispatch(updateFormDataStep4(newStep4Form));
      AppDispatch(updateFormDataStep5(newStep5Form));
      response = await performSaveDraftManual({applicationStart: startApplicationFormData, applicationStep1: applicationStep1FormData, applicationStep2: applicationStep2FormData, applicationStep3: ConveyancingValue, applicationStep4: newStep4Form, applicationStep5: newStep5Form, applicationId, singpassToken});
    }else{
      response = await performSaveDraft(ConveyancingValue, 3, applicationId, singpassToken);
    }
    AppDispatch(updateFormData(ConveyancingValue));

    // Update override eligibility value
    const overrideEligibilityCheck = new EligibilityOverride({application_uuid: applicationId?.toString()});

    if (ConveyancingValue.current_solicitor_type && bypassSolicitors.current) {
      overrideEligibilityCheck.current_household_solicitor = EligibilityCheck.BYPASS;
    }

    if (ConveyancingValue.proposed_solicitor_type && bypassSolicitors.proposed) {
      overrideEligibilityCheck.proposed_household_solicitor = EligibilityCheck.BYPASS;
    }

    overrideEligibilityCheck.administrative_fee = bypassPayments.admin ? EligibilityCheck.BYPASS : EligibilityCheck.EXEMPT;
    overrideEligibilityCheck.valuation_fee = bypassPayments.valuation ? EligibilityCheck.BYPASS : EligibilityCheck.EXEMPT;

    await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_OverrideEligibilityCheck, overrideEligibilityCheck);


    if(requiredAlert){
      setSaveDraftSuccess(response);
    }
  }, [ConveyancingValue, applicationId, singpassToken, isValueChanged, applicationStartFormData, applicationStep1FormData, applicationStep2FormData, performSaveDraft, performSaveDraftManual])

  const handleSaveDraft = useCallback(() => {
    AppDispatch(updateFormData(ConveyancingValue));
    saveDraft(true);
    setSaveDraftModalOpen(false);
  }, [saveDraft, ConveyancingValue])

  const saveDraftLeavePage = useCallback(async()=>{
    await saveDraft(false);
  },[navigate, saveDraft])

  const toggleSaveDraftModal = useCallback(() => {
    setSaveDraftModalOpen((prev) => !prev);
}, [saveDraftModalOpen])

  const removeApplication = useCallback(async () => {
    if(applicationId){
      try {
        await PolymerAxios(loginUser?.uinfin ?? "", singpassToken)
          .post(`${API_ApplicationRemove}/${applicationId}`)
          .then((res) => res.data);
      } catch (error) {
        console.log(error);
      }
    }
  }, [singpassToken, applicationId, loginUser]);


  const navigateBack = useCallback(()=>{
    navigate("/application-coo/stage-a/financing")
  },[navigate])

  const saveValuesAndGoBack = useCallback(() => {
    AppDispatch(updateFormData(ConveyancingValue));
    AppDispatch(setBackTriggered(true));
    navigateBack();
  }, [ConveyancingValue, navigateBack])

  const toggleBackConfirmationModal = useCallback(() => {
    const currentTimeString = moment().format('yyyy-MM-DD HH:mm:ss');
    const alreadyTriggered = sessionStorage.getItem("back_triggered");
    if (
      alreadyTriggered !== "true" &&
      backTriggeredSlice.is_back_triggered && 
      backConfirmationModalOpen === false &&
      (backTriggeredSlice.last_back_triggered_time === "" ||
        moment(currentTimeString).diff(moment(backTriggeredSlice.last_back_triggered_time), "seconds") >= 600)
    ) {
      sessionStorage.setItem("back_triggered", "true");
      AppDispatch(setLastBackTriggeredTime(currentTimeString));
      AppDispatch(setBackTriggered(false));
      setBackConfirmationModalOpen((prev) => !prev);
    }else{
      setBackConfirmationModalOpen(false);
    }
  }, [backConfirmationModalOpen, backTriggeredSlice]);

  const proceedNext = useCallback(() => {
    setForceError(false);
    if(!isBtnValid){
      setForceError(true);
      return;
    }

    saveDraft(false).then(() => {
      AppDispatch(updateStageAStep3(true));
      navigate('/application-coo/stage-a/upload-documents');
    })

  },[isBtnValid, navigate, AppDispatch, saveDraft])

  const handleHoldingTypeChange = useCallback((e: any) => {
    ConveyancingSetFormValue({...ConveyancingValue, holding_type:e as HoldingTypeEnum});
  }, [ConveyancingValue, ConveyancingSetFormValue])

  const handleSelectAttendHdb = useCallback((e: boolean) => {
      ConveyancingSetFormValue({...ConveyancingValue, proposed_same_solicitor:false, attend_hdb_in_person: e, proposed_solicitor_type: undefined, current_solicitor_type : undefined, proposed: new LegalRepresentation(), current: new LegalRepresentation() });
  }, [ConveyancingValue, ConveyancingSetFormValue])

  const handleSelectCurrentSolicitor = useCallback((e: any) => {
    ConveyancingSetFormValue({...ConveyancingValue, current_solicitor_type: e, proposed_same_solicitor : false, proposed_solicitor_type: undefined, proposed: new LegalRepresentation()});
  }, [ConveyancingValue, ConveyancingSetFormValue])

  const handleSelectProposedSolicitor = useCallback((e: any) => {
    ConveyancingSetFormValue({...ConveyancingValue, proposed_solicitor_type: e});
  },[ConveyancingValue, ConveyancingSetFormValue])


  useEffect(() => {
    if(saveDraftSuccess){
        setTimeout(() => {
            setSaveDraftSuccess(false);
        }, 3000)
    }
  }, [saveDraftSuccess])


  useEffect(() => {
    setAdditionalData({is_holding_type_proposed_legal_required: isHoldingTypeProposedLegalRequired, is_remission:isRemission, is_proposed_conveyancing_hdb: isProposedConveyancingHdb, is_current_direct_conveyancing:isCurrentDirectConveyancing, is_proposed_direct_conveyancing:isProposedDirectConveyancing});
  }, [isHoldingTypeProposedLegalRequired, isRemission, isProposedConveyancingHdb, isCurrentDirectConveyancing, setAdditionalData, isProposedDirectConveyancing])

  useEffect(() => {
      const selectedButNoHdbSelectionForCurrent = initApplicationStep3FormData.current_solicitor_type === SolicitorTypeEnum.hdb_solicitor 
      && processLegalRepresentationDropdownForCurrent.every(item => item.value !== SolicitorTypeEnum.hdb_solicitor);

      const selectedButNoHdbSelectionForNew = initApplicationStep3FormData.proposed_solicitor_type  === SolicitorTypeEnum.hdb_solicitor 
      && processLegalRepresentationDropdownForNew.every(item => item.value !== SolicitorTypeEnum.hdb_solicitor);

      if(selectedButNoHdbSelectionForCurrent || selectedButNoHdbSelectionForNew){
          ConveyancingSetFormValue(new ApplicationStep3());
      }
  }, [])

  return (
    <ApplicationCooLayout>
      <div className='polymer-application-coo__wrapper'>
        <div>
          <TextSubheader subheaderMain="Stage A: Start Application" subheaderSub={startApplicationFormData.selected_hdb_property?.address} paddingLeftRight={42}/>
        </div>

        <Stepper activeStep={activeStep} items={stepperItems} style={{margin:"62px auto"}}/>
          <div className='d-flex justify-content-center'>
            <SectionCard disabled={isInit} onClick={toggleBackConfirmationModal} className='flex-fill' activeStep={activeStep} stepperItems={stepperItems} titleChildren={
                <P2TextDescription title={stepperItems[activeStep-1]?.title}/>
              }
              contentChildren={
                <div>
                  {isHoldingTypeProposedLegalRequired && <>
                  <div className='px-4'>

                  <P2TextDescription color='#000' size='1.5rem' title='Holding Type'/>
                  <div className='mb-2' style={{marginTop: 32}}>
                    <P2TextDescription size='1.125rem' color='#000' title={"Summary"}/>
                  </div>
                  <HoldingTypeTable ConveyancingValue={ConveyancingValue}/>


                  {!isSoleOwnership && <>
                    <div className='d-flex flex-column' style={{gap:"4px", margin:"32px 0 16px 0"}}>
                      <P2TextDescription size='1.25rem' color='#000' title={"Selection of Holding Type"} />
                      <P2TextLabel bold="500" fontSize='1.125rem' label={"Please specify the holding type for the proposed household."}/>
                    </div>
                    <Dropdown forceError={forceError} style={{fontWeight:700}} setSelectedDropdown={handleHoldingTypeChange} disabled={ConveyancingValue.is_holding_type_confirm} selectedDropdown={ConveyancingValue.holding_type} label='Holding Type' placeholder='Please indicate holding type' items={proposedHousingTypeItems}/>
                    <p hidden>is_confirm = {ConveyancingValue.is_holding_type_confirm ? "true" : "false"}</p>
                    <p hidden>holding_type value = {ConveyancingValue.holding_type}</p>
                  </>}
                  <div style={{marginTop:16}}>
                    <HoldingTypeSegment forceError={forceError} holding_type={ConveyancingValue.holding_type} ConveyancingSetFormValue={ConveyancingSetFormValue} ConveyancingValue={ConveyancingValue} ConveyancingErrors={ConveyancingErrors}/>
                  </div>
                  </div>

                  <Separator style={{margin:"48px 0 24px"}} variant='solid'/>
                </>}

                <div className='px-4'>
                  <P2TextDescription color='#000' title='Appointing a Lawyer' description={'In order to transfer ownership of a flat, it is necessary to engage the services of a lawyer. Depending on the type of conveyancing required, different types of lawyers may be suitable for the appointment.'}/>
        
                  <div style={{marginTop:"32px"}}>
                    <P2TextLabel bold="700" fontSize='1.125rem' label={"Are all owners willing and able to attend the completion appointment in person?"} required/>
                    <RadioGroup style={{marginTop:20}} layout='inline' items={Radio_Attend_HDB} onItemSelect={handleSelectAttendHdb} value={ConveyancingValue.attend_hdb_in_person} required label={''}/>
                  </div>

                  <Separator style={{margin:"32px 0"}}/>

                  <div ref={anchorRef} className='mt-4 mb-2'>
                    <P2TextDescription size='1.125rem' color='#000' title={"Summary"}/>
                  </div>

                  <SolicitorTable ConveyancingValue={ConveyancingValue}/>

                  <div style={{marginTop:"32px", marginBottom:"16px"}}>
                    <P2TextLabel bold="700" color={"#000"} label={"Selection of Lawyers"}/>
                    <P2TextLabel bold={500} label="Please select lawyers to represent owner(s)." hasTooltip={true} tooltipContent={<><div>Applicants may appoint HDB or private lawyers. If HDB is appointed, the current owner(s) and/or proposed owner(s) will need to attend an appointment at HDB's office in person to sign the legal documents and make payment for the related fees and charges for the ownership change.</div><br /><div>It is at HDB's discretion to decide whether HDB can act for the parties. The parties need to engage private lawyers if HDB is unable to accept the appointment, or if any of the parties are unable to attend the completion in person.</div></>}/>
                  </div>
                  
                  <>
                    <Dropdown forceError={forceError} disabled={currentDropdownDisabled} hasTooltip setSelectedDropdown={handleSelectCurrentSolicitor} selectedDropdown={ConveyancingValue.current_solicitor_type} label={isCurrentDirectConveyancing ? "Lawyer for current owners' conveyancing." : currentLegalRepresentationTitle} placeholder='Please indicate lawyer type' required items={processLegalRepresentationDropdownForCurrent} tooltipContent={<span>You would be required to engage a lawyer for the following:<div>1) Discharge of current mortgage loan</div><div>2) Obtaining fresh mortgage loan</div><div>3) Conveyancing for the ownership change (current owners)</div><div>4) Conveyancing for the ownership change (proposed owners)</div><br /><div>The change in flat ownership is a conveyancing process. You are recommended to have the same lawyer for process to expedite and reduce the need to liaise with multiple parties.</div></span>}/>
                    <div style={{margin:"16px 0 0"}}>
                      <LegalRepresentationSegment forceError={forceError} onConfirmCallback={scrollToTable} user_type={"current"} loan_type={currentLoanType} legalRepresentation={ConveyancingValue.current} solicitor_type={ConveyancingValue.current_solicitor_type} ConveyancingSetFormValue={ConveyancingSetFormValue} ConveyancingErrors={ConveyancingErrors.current} directly_conveyancing={isCurrentDirectConveyancing}/>
                    </div>
                  </>

                  {isHoldingTypeProposedLegalRequired && <>
                    <>
                      <div style={{marginTop:"32px"}}>
                        <P2TextLabel bold="700" color={"#000"} label={newLegalRepresentationTitle} required hasTooltip tooltipContent={"As a change in flat ownership is a conveyancing transaction, current owners would need to engage the service of lawyers to act for the fresh mortgage loan (if any)."} />
                      </div>

                      {/* To hide checkbox when not in used, requested by jesslyn in whatsapp on March 10,2024*/}
                      {enableProposeSameSolicitor && <div style={{marginTop:"10px"}}>
                        {!(isCurrentDirectConveyancing || isProposedDirectConveyancing )&& <P2Checkbox variant={enableProposeSameSolicitor ? "default" : "disabled"} isActive={ConveyancingValue?.proposed_same_solicitor} onClick={onSelectSameSolicitor} description={<P2TextLabel label={<span style={{fontSize:"1rem"}} className='m-0'>Proposed owners are represented by the same lawyer as above.</span>} />} />}
                      </div>}
                      <Dropdown forceError={forceError} disabled={proposedDropdownDisabled || ConveyancingValue?.proposed_same_solicitor} style={{marginTop:10}} setSelectedDropdown={handleSelectProposedSolicitor} selectedDropdown={ConveyancingValue.proposed_solicitor_type} label={""} placeholder='Please indicate lawyer type' required items={processLegalRepresentationDropdownForNew}/>
                    </>
                    <div style={{margin:"16px 0 0"}}>
                      <LegalRepresentationSegment forceError={forceError} onConfirmCallback={scrollToTable} user_type={"proposed"} legalRepresentation={ConveyancingValue.proposed} solicitor_type={ConveyancingValue.proposed_solicitor_type} ConveyancingSetFormValue={ConveyancingSetFormValue} ConveyancingErrors={ConveyancingErrors.proposed} directly_conveyancing={isProposedDirectConveyancing}/>
                    </div>
                  </>}
                </div>
                {/* NOTE: isFlatResale, will hide and directly set valuation value to "V" */}
                {isHoldingTypeProposedLegalRequired && displayValuation && ConveyancingValue?.proposed_solicitor_type && <>
                  <Separator style={{margin:"48px 0 24px"}} variant='solid'/>
                  <div className='px-4'>
                    <P2TextDescription color='#000' size='1.5rem' title='Valuation options for stamp duty' description={'Stamp duty is payable on the change in ownership of HDB flat. Stamp duty payable is based on the Stamp Duties Act which is under the purview of Inland Revenue Authority of Singapore (IRAS). For the change in ownership, stamp duty may be payable. The amount of stamp duty payable will be based on the market value of the flat.'}/>
                    <ValuationStampDutyForm setFormValue={ConveyancingSetFormValue} conveyancing_values={ConveyancingValue} errors={ConveyancingErrors}/>
                  </div>
                </>}
              </div>
            }
          />
        </div>

        <Separator style={{margin:"32px 42px"}}/>

        <div className='polymer-shared-alert-container'>
          <div style={{ marginTop: 24, marginBottom: 24 }}>
            {saveDraftSuccess && <SaveDraftAlert/>}
          </div>
        </div>
        <LeavingPageModal 
          onSubmit={saveDraftLeavePage}
          onCancel={removeApplication}
          conveyancingValue={ConveyancingValue}
        /> 

        <BackConfirmationModal onSubmit={toggleBackConfirmationModal} onClose={toggleBackConfirmationModal} isOpen={backConfirmationModalOpen}/>
        <SaveDraftModal onSubmit={handleSaveDraft} onCancel={removeApplication} onClose={toggleSaveDraftModal} isOpen={saveDraftModalOpen}/>

        <div className='polymer-application-coo__card-button'>
          <P2ButtonGroup>
            <P2Button onClick={saveValuesAndGoBack} variant="outline-primary">Back</P2Button>
            <P2Button variant={"outline-primary"} onClick={toggleSaveDraftModal}>Save as draft</P2Button>
            <P2Button disabled={!isBtnValid} onClick={proceedNext} variant="primary-1">Next</P2Button>
          </P2ButtonGroup>
        </div>
      </div>
    </ApplicationCooLayout>


  )
}

export default ApplicationCOOStep3

